import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AmenitiesComponent } from '@/components/reusable/NewAmenitiesComponent/AmenitiesComponent';
import { GMapsComponent } from '@/components/reusable/GMapsComponent/GMapsComponent';
import { ReservationForm } from '@/components/general/Forms/NewReservationFormCopy';
import ShortReservationDetail from '@/components/general/Forms/New2ndShortReservationDetail/ShortReservationDetail';
import CommmentsComponent from '@/components/reusable/NewCommentsComponent/CommentsComponent';
import Label from '@/components/form/Label/Label';
import ReactPixel from 'react-facebook-pixel';
import NewSpaceCardRedesignDetailVersion from '@/components/reusable/NewSpaceCardRedesignDetailVersion2nd/NewSpaceCardRedesignDetailVersion';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'react-comments-section/dist/index.css';
import './ProductDetails.scss';
import zIndex from '@mui/material/styles/zIndex';

const translations = {
  'Sala de Juntas': 'Meeting Room',
  Terrazas: 'Terrace',
  Coworking: 'Day Pass',
};

const HeadComponent = props => {
  const { spaceInfo, extraClass, lenguage } = props;
  const containerClass =
    'justify-between bgGradientBlue fontWhite border-rad8px padlr10 padb20 ' +
    extraClass;
  const translatedType =
    translations[spaceInfo?.subtype_title] || spaceInfo?.subtype_title;
  return (
    <FlexContainer className={containerClass}>
      <span
        style={{ zIndex: 2 }}
        className="leftPill bgPurple7 fontGray500 text-12 padtb4 padlr10 pos-abs"
      >
        <strong>Elegant</strong>
      </span>
      <FlexContainer
        className={
          'flex-column align-self-left text-14 align-center margt20 gap-10'
        }
      >
        <Label className={'margt10 text-22 m-text-18'}>
          <strong>
            {lenguage === 'ES'
              ? spaceInfo?.subtype_title + ': ' + spaceInfo?.relationship_title
              : translatedType + ': ' + spaceInfo?.relationship_title}
          </strong>
        </Label>
        <FlexContainer className={'gap-8 text-12 align-center'}>
          <Label className={'text-16 m-text-14'}>
            <i className={'far fa-star'} /> 100% | 2 ratings
          </Label>
        </FlexContainer>
        <Label className={'text-16 m-text-14 margt26'}>
          {spaceInfo?.space_address}
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

const SearchBar = props => {
  const { languageData, onBack } = props;
  return (
    <FlexContainer
      className={'margt20 margb10 align-items-center padlr8 cursorPointer'}
      onClick={onBack}
    >
      <i className="fa fa-chevron-left"></i>
      <div className={'fontBlack text-12 margl10'}>
        {languageData === 'EN'
          ? 'Back to booking details'
          : 'Volver a los detalles de reserva'}
      </div>
    </FlexContainer>
  );
};

const SpaceDetailInfo = props => {
  const {
    spaceData,
    spaceComment,
    isFullScreenMap,
    setIsFullScreenMap,
    goToWorkspaceMap,
  } = props;
  const lenguage = useSelector(state => state.lenguage?.lang);
  const goToSpaceDetails = () => {
    ReactPixel.trackCustom('clickReservationButton', { clave: spaceData });
  };
  const wifi = true;
  const coffee = spaceData?.coffe_water === '1' ? true : false;
  const parking = spaceData?.parking === '1' ? true : false;
  const staff = spaceData?.staff === '1' ? true : false;
  const cleaning_service = spaceData?.cleaning_service === '1' ? true : false;
  const printing_service = spaceData?.printing_service === '1' ? true : false;
  const common_areas = spaceData?.common_areas === '1' ? true : false;
  const convention_hall = spaceData?.convention_hall === '1' ? true : false;
  const snacks = spaceData?.snacks === '1' ? true : false;
  const phone_service = spaceData?.phone_service === '1' ? true : false;

  if (spaceData) {
    return (
      <FlexContainer
        className={'flex-column bgWhite productPreList m-padlr0 padlr130'}
      >
        <FlexContainer className={'m-flex-column width100 margt20 gap-20'}>
          {isFullScreenMap && (
            <GMapsComponent
              spaceData={spaceData}
              customHeight={'400px'}
              setIsFullScreenMap={setIsFullScreenMap}
            />
          )}
          {!isFullScreenMap && (
            <FlexContainer className={'flex-column width100'}>
              <FlexContainer className={'flex-column width100 m-gap-10'}>
                <SearchBar languageData={lenguage} onBack={goToWorkspaceMap} />
                <FlexContainer className="flex-column width100 pos-rel ">
                  <NewSpaceCardRedesignDetailVersion
                    key={1}
                    spaceInfo={spaceData}
                    handleDetailButton={goToSpaceDetails}
                  />
                </FlexContainer>
                <FlexContainer
                  className={'flex-column m-padlr4 m-gap-10 gap-10'}
                >
                  <HeadComponent
                    spaceInfo={spaceData}
                    lenguage={lenguage}
                    extraClass={'padt10'}
                    isFullScreenMap={isFullScreenMap}
                    setIsFullScreenMap={setIsFullScreenMap}
                  />
                  <GMapsComponent
                    spaceData={spaceData}
                    lenguage={lenguage}
                    setIsFullScreenMap={setIsFullScreenMap}
                  />
                  <CommmentsComponent
                    spaceComment={spaceComment}
                    lenguage={lenguage}
                    extraClass={''}
                  />
                  <FlexContainer className={'mobileCol-desktopRow gap-10'}>
                    <FlexContainer
                      className={'flex-column format50 m-format100 gap-10'}
                    >
                      <DetailSpecsSection
                        spaceData={spaceData}
                        lenguage={lenguage}
                      />
                      <FacilitiesInclude
                        spaceDetail={spaceData}
                        lenguage={lenguage}
                      />
                    </FlexContainer>
                    <FlexContainer
                      className={'flex-column format50 m-format100 gap-10'}
                    >
                      <AmenitiesComponent
                        wifi={wifi}
                        coffee={coffee}
                        parking={parking}
                        staff={staff}
                        cleaning_service={cleaning_service}
                        printing_service={printing_service}
                        common_areas={common_areas}
                        convention_hall={convention_hall}
                        snacks={snacks}
                        phone_service={phone_service}
                        lenguage={lenguage}
                      />
                      <NeedToKnow spaceDetail={spaceData} lenguage={lenguage} />
                    </FlexContainer>
                  </FlexContainer>
                </FlexContainer>
              </FlexContainer>
            </FlexContainer>
          )}
        </FlexContainer>
      </FlexContainer>
    );
  } else {
    return <></>;
  }
};

const DetailSpecsSection = props => {
  const { lenguage, spaceData } = props;
  return (
    <FlexContainer
      className={'flex-column m-padlr20 bgGradientBlue border-rad8px padlr10'}
    >
      <Label className={'text-16 margt20 text-justify fontWhite fontWhite'}>
        <strong>
          {lenguage === 'EN'
            ? 'Why Book With Us?'
            : '¿Por qué reservar con nosotros?'}
        </strong>
      </Label>
      <Label type="text-14" className={'width100 text-justify fontWhite'}>
        <div
          dangerouslySetInnerHTML={{
            __html:
              lenguage === 'EN'
                ? spaceData?.space_details_en
                : spaceData?.space_details,
          }}
        />
      </Label>
    </FlexContainer>
  );
};

const FacilitiesInclude = props => {
  const { spaceDetail, lenguage } = props;
  return (
    <FlexContainer
      className={
        'bgGradientBlue border-rad8px fontWhite m-flex-column padt20 padlr130 m-padlr20 gap-20'
      }
    >
      <FlexContainer className={'flex-column'}>
        <Label className={'text-16 width100 text-justify'}>
          <strong>
            {lenguage === 'EN' ? 'Why We Like It?' : '¿Por qué nos gusta?'}
          </strong>
        </Label>
        <Label type="text-14" className={'width100 text-justify'}>
          <div
            dangerouslySetInnerHTML={{
              __html:
                lenguage === 'EN'
                  ? spaceDetail?.space_details_general_en
                  : spaceDetail?.space_details_general,
            }}
          />
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

const NeedToKnow = props => {
  const { spaceDetail, lenguage } = props;
  console.log('aqui imoresion', spaceDetail);

  const defaultText =
    lenguage === 'EN'
      ? 'Stylish and low-key, with Santa María soul. Textured walls, soft lighting, and café-like comfort set the mood. Located steps from the Kiosco Morisco. Ergonomic chairs, fast Wi-Fi, and a gallery-worthy table made for deep work and creative chats. Coffee’s always flowing. Vibes always on point. Meeting room'
      : 'Estiloso y discreto, con alma de Santa María. Paredes con textura, iluminación suave y la comodidad de un café marcan la atmósfera. Ubicado a pasos del Kiosco Morisco. Sillas ergonómicas, Wi-Fi rápido y una mesa digna de galería pensada para trabajo profundo y charlas creativas. El café nunca falta. La vibra siempre está en su punto. Sala de reuniones.';

  const needToKnowText =
    lenguage === 'EN'
      ? spaceDetail?.need_to_know_en?.trim()
        ? spaceDetail.need_to_know_en
        : defaultText
      : spaceDetail?.need_to_know?.trim()
        ? spaceDetail.need_to_know
        : defaultText;

  return (
    <FlexContainer
      className={
        'bgGradientBlue border-rad8px fontWhite m-flex-column padt20 padlr130 m-padlr20 gap-20'
      }
    >
      <FlexContainer
        className={'flex-column format180 m-format100 justify-between'}
      >
        <FlexContainer className={'flex-column'}>
          <Label className={'text-16 width100 text-justify'}>
            <strong>
              {lenguage === 'EN' ? 'Need to Know' : 'Lo que necesitas saber'}
            </strong>
          </Label>
          <Label
            type="text-14"
            className={'width100 text-justify margt10 margb30'}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: needToKnowText,
              }}
            />
          </Label>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

const NewProductDetails = props => {
  const { spaceDetail, spaceComments, modalOpen, goToWorkspaceMap } = props;
  console.log(modalOpen);
  const [modalIsOpen, setIsOpen] = useState(modalOpen);
  const [mapIsOpen, setMapIsOpen] = useState(false);
  const [isFullScreenMap, setIsFullScreenMap] = useState(false);
  const lenguage = useSelector(state => state.lenguage?.lang);
  const navigate = useNavigate();
  const location = useLocation();

  let subtitle;

  const currentPath = location.pathname;

  const openModal = () => {
    //setIsOpen(true);
    console.log('hola');
    const newPath = `${currentPath}/true`;
    navigate(newPath);
  };

  const afterOpenModal = () => {
    subtitle.style.color = '#f00';
  };

  const closeModal = () => {
    //setIsOpen(false);
    const segmentToRemove = '/true';
    let newPath = currentPath;
    if (currentPath.endsWith(segmentToRemove)) {
      newPath = currentPath.slice(0, -segmentToRemove.length);
    } else {
      console.warn(
        "La URL actual no termina en '/true'. No se realiza ningún cambio.",
      );
      return;
    }
    navigate(newPath);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    return () => clearTimeout(timer);
  }, []);
  return (
    <FlexContainer className={'productDetails flex-column m-margt20 margt100'}>
      {!mapIsOpen && (
        <>
          {!modalIsOpen && (
            <>
              <FlexContainer
                className={'m-flex-column bottom0 pos-fixed width100'}
                style={{ zIndex: 3 }}
              >
                <ShortReservationDetail
                  className={' m-formatAuto flex-column'}
                  spaceDetail={spaceDetail}
                  onClick={openModal}
                />
              </FlexContainer>
              <SpaceDetailInfo
                spaceData={spaceDetail}
                spaceComment={spaceComments}
                lenguage={lenguage}
                isFullScreenMap={isFullScreenMap}
                setIsFullScreenMap={setIsFullScreenMap}
                goToWorkspaceMap={goToWorkspaceMap}
                closeButton={''}
              />{' '}
            </>
          )}

          {modalIsOpen && (
            <ReservationForm
              className={
                'bgGradientBlue border-rad8px padlr20 m-padlr10 fontWhite'
              }
              spaceDetail={spaceDetail}
              backButton={closeModal}
            />
          )}
        </>
      )}
      {mapIsOpen && (
        <GMapsComponent spaceData={spaceDetail} lenguage={lenguage} />
      )}
    </FlexContainer>
  );
};

export default NewProductDetails;
